/**
 * @generated SignedSource<<99c56ff7af5d3d253f0ad61e781b1f5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getInvestimentsPropertiesQuery$variables = {
  property_ids: ReadonlyArray<number>;
};
export type getInvestimentsPropertiesQuery$data = {
  readonly sys_property_relationships: ReadonlyArray<{
    readonly property_id_to: number;
  }>;
};
export type getInvestimentsPropertiesQuery = {
  response: getInvestimentsPropertiesQuery$data;
  variables: getInvestimentsPropertiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "property_ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "distinct_on",
        "value": "property_id_to"
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_in",
                "variableName": "property_ids"
              }
            ],
            "kind": "ObjectValue",
            "name": "property_id_from"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_property_relationships",
    "kind": "LinkedField",
    "name": "sys_property_relationships",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "property_id_to",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getInvestimentsPropertiesQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getInvestimentsPropertiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a48680ec3fa210b03df86e8df76fadcd",
    "id": null,
    "metadata": {},
    "name": "getInvestimentsPropertiesQuery",
    "operationKind": "query",
    "text": "query getInvestimentsPropertiesQuery(\n  $property_ids: [Int!]!\n) {\n  sys_property_relationships(where: {property_id_from: {_in: $property_ids}}, distinct_on: property_id_to) {\n    property_id_to\n  }\n}\n"
  }
};
})();

(node as any).hash = "db6be183fd865d5ae1bafcce22feb820";

export default node;
